import { Eye } from "lucide-react";

import { useAuthStore } from "@/features/auth/store";

/** Thin always-on-top bar shown whenever the current session is an admin "se som
 *  låntaker" preview — so it's never mistaken for a real logged-in account. */
export function ImpersonationBanner() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  if (!user?.impersonated) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-2 bg-amber-500/90 px-3 py-1.5 text-[12px] font-medium text-[#1a1400]">
      <Eye className="size-3.5" />
      Admin-forhåndsvisning som {user.name} — ikke en ekte innlogging
      <button type="button" onClick={logout} className="ml-2 underline underline-offset-2">
        Avslutt
      </button>
    </div>
  );
}
